import { api_host } from '../../common/globals/constants';

export const getAudioBinary = (objective, token, hashMd5) =>
    fetch(api_host + `/reporte/general/objetivos/${objective}/audios_ivr/audio/?token=${token}&hash=${hashMd5}`)
        .then(response => response.json())
        .then(base64Data => {
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'audio/wav' });
            return URL.createObjectURL(blob);
        });
